module.exports = __webpack_public_path__ + "static/media/close_circle.a2d716c6.svg";